module.exports = __webpack_public_path__ + "img/london-office-2.ba092445.jpg";